import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Dictionary } from '../../common/dictionary';

const language: string | null = localStorage.getItem('language');

export const phrasesSlice = createSlice({
  name: 'phrases',
  initialState: {
		value: Dictionary.getPhrases(language!)
	},
  reducers: {
    setPhrases: (state, action: PayloadAction<any>) => {
      state.value = action.payload
    },
  },
});

export const { setPhrases } = phrasesSlice.actions
export default phrasesSlice.reducer